import React from 'react'
import SegmentsPlayer from '../SegmentsPlayer'
import {usePlayerIFrameLogic} from './usePlayerIFrame'
import {PlayerIFrameProps} from './types'
import UploadProgress from './UploadProgress'
import './PlayerIFrame.scss'

const PlayerIFrame: React.FC<PlayerIFrameProps> = props => {
  const {
    missingPowtoonId, isLoading, segments, viewEvents, unifiedVideoSegment, uploadProgress, thumbUrl
  } = usePlayerIFrameLogic(props)

  const [isUploadFinished, setIsUploadFinished]  = React.useState(false)
  const onCompletedAnimation = () => setIsUploadFinished(true)
  
  if (uploadProgress !== undefined && !isUploadFinished) {
    return <UploadProgress progress={uploadProgress} onCompletedAnimation={onCompletedAnimation} thumbUrl={thumbUrl}/>
  }
  
  return (
    <div>
      {missingPowtoonId
        ? (
          <div styleName="missing-id">Missing Powtoon Id ddd</div>
        ) :
        unifiedVideoSegment
          ? <SegmentsPlayer isLoading={isLoading} segments={unifiedVideoSegment} {...props} {...viewEvents} />
          : <SegmentsPlayer isLoading={isLoading} segments={segments} {...props} {...viewEvents} />
      }
    </div>
  )
}

export default PlayerIFrame
